import { connect } from 'react-redux';
import { Status } from '~/Api/DataSourceStatus';

import { fetchStatuses } from './actions';
import { State } from './reducer';
import StatusesPage from './StatusesPage';

interface Props {
	isFetching: boolean;
	statuses: Status[] | null;
}

function mapStateToProps(state: { dataSourceStatus: State }): Props {
	return {
		isFetching: state.dataSourceStatus.isFetching,
		statuses: state.dataSourceStatus.statuses,
	};
}

const actions: { onFetch: typeof fetchStatuses } = {
	onFetch: fetchStatuses,
};

export default connect(mapStateToProps, actions)(StatusesPage);
